import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { getAttemptAssessmentData } from "../services/awsServices";
import { getAssessmentContentsData } from "../slices/courseraSlice";
import CourseTab from "./CourseTab";
import MainAssessmentTab from "./MainAssessmentTab";
import Projects from "./Projects";

const Courses = () => {
  const dispatch = useDispatch();
  const [AttemptedId, setAttemptedId] = useState([]);
  const [AttemptedData, setAttemptedData] = useState();
  const email = localStorage.getItem("username");
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("Assessment");

  useEffect(() => {
    // Extract tab key from URL query parameters
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (tab) {
      setActiveKey(tab);
    }
  }, [location]);

  const onChange = (key) => {
    setActiveKey(key);
    // Update URL with the new active tab
    const params = new URLSearchParams(location.search);
    params.set("tab", key);
    navigate({ search: params.toString() });
  };

  const getAttemptedResults = async () => {
    const ids = [];
    const res = await getAttemptAssessmentData(email);
    console.log(res, "adasdad");
    setAttemptedData(res?.data?.data?.testInstances);
    res?.data?.data?.testInstances?.map((items) => {
      ids.push(items?.assessmentId);
    });
    setAttemptedId(ids);
  };

  useEffect(() => {
    dispatch(getAssessmentContentsData());
    getAttemptedResults();
  }, []);
  return (
    <div className=" flex gap-5 mb-10">
      <div className="w-full ">
        <Tabs activeKey={activeKey} onChange={onChange}>
          <Tabs.TabPane key="Assessment" tab="Assessment">
            <MainAssessmentTab
              ids={AttemptedId}
              AttemptedData={AttemptedData}
            />
          </Tabs.TabPane>
          <Tabs.TabPane key="Courses" tab="Courses">
            <CourseTab />
          </Tabs.TabPane>
          <Tabs.TabPane key="Projects" tab="Projects">
            <Projects />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default Courses;
